module.exports = {
  tempUploadedProVideoName: null,
  tempUploadedProVideoIndex: -1,
  proSettings: null,
};
